var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGhaynMedial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x84\xB6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M31.13,22.16s-4-.8-4.1-1.5.8-3.7,1.2-3.8,3.6.3,4.1.9-.4,3.3-.6,3.7S31.53,22.26,31.13,22.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7,
    d: "M32.63,17.48h0l-5.71,4.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M36.9,35c.1-3,3.5-4.2,2.7-6.2-1.2-3.1-7.2-4.7-10.8-2,0,0-2.7,1.2-1.7,3.2s3.3,2,2.9,3.7-2.7,1.4-4.6,1.4-14,.3-14,.3V40s14.9,1.1,16.4,0,4.3-4.1,5.6-3.2,3.3,3.5,5.9,3.6c2.8.2,13-.4,13-.4V35S36.9,36.1,36.9,35Zm-4.1-2.2s-2-1.9-2.1-3.2,3.4-2,4.8-.9S34.5,33.3,32.8,32.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7,
    d: "M52.74,37.91S39.6,39,37,37.5s-7.6-4.9-8.1-7.3,5.2-4.5,7.5-3,0,6.7-6.5,9.1S11,37.93,11,37.93"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhaynMedial);
export default __webpack_public_path__ + "static/media/ghayn-medial.a8fa076f48c2c22c7859d88813d6a1da.svg";
export { ForwardRef as ReactComponent };